import React, { useState } from "react";
import getModalStyle from "../../../../util/getModalStyle";

function useJobsiteSelector(handleModalDetails: () => void) {
  const [modalStyle] = useState(() => getModalStyle(50, 50));

  const [addressErr, setAddressErr] = useState(false);

  const role = JSON.parse(sessionStorage.getItem("role") || JSON.stringify(""));

  const hasAdminAccess = role === "Admin" || role === "Inside Sales";

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      return handleModalDetails();
    }
  };

  const preventEnterEffects = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  return {
    preventEnterEffects,
    handleKeyDown,
    hasAdminAccess,
    modalStyle,
    addressErr,
    setAddressErr
  };
}

export default useJobsiteSelector;
